// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LinkProjectRequest
 */
export interface LinkProjectRequest {
  /**
   *
   * @type {string}
   * @memberof LinkProjectRequest
   */
  projectID: string;
  /**
   * If true, forces relinking even if already linked.
   * @type {boolean}
   * @memberof LinkProjectRequest
   */
  shouldRelink?: boolean | null;
  /**
   * If true, forces relinking of the organization.
   * @type {boolean}
   * @memberof LinkProjectRequest
   */
  shouldRelinkOrganization?: boolean | null;
}

/**
 * Check if a given object implements the LinkProjectRequest interface.
 */
export function instanceOfLinkProjectRequest(
  value: object,
): value is LinkProjectRequest {
  if (!('projectID' in value) || value['projectID'] === undefined) return false;
  return true;
}

export function LinkProjectRequestFromJSON(json: any): LinkProjectRequest {
  return LinkProjectRequestFromJSONTyped(json, false);
}

export function LinkProjectRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LinkProjectRequest {
  if (json == null) {
    return json;
  }
  return {
    projectID: json['projectID'],
    shouldRelink:
      json['shouldRelink'] == null ? undefined : json['shouldRelink'],
    shouldRelinkOrganization:
      json['shouldRelinkOrganization'] == null
        ? undefined
        : json['shouldRelinkOrganization'],
  };
}

export function LinkProjectRequestToJSON(json: any): LinkProjectRequest {
  return LinkProjectRequestToJSONTyped(json, false);
}

export function LinkProjectRequestToJSONTyped(
  value?: LinkProjectRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    projectID: value['projectID'],
    shouldRelink: value['shouldRelink'],
    shouldRelinkOrganization: value['shouldRelinkOrganization'],
  };
}
